import { render, staticRenderFns } from "./ConfirmCancellation.vue?vue&type=template&id=2a53b356&"
import script from "./ConfirmCancellation.vue?vue&type=script&lang=js&"
export * from "./ConfirmCancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports